import ComingSoon from 'components/ComingSoon';

export const MarketPlace = () => (
  <ComingSoon text="This section allocates the products and services of startups and experts onboarded on TransparenTerra. A unique marketplace is coming soon, and Opt-in to our email list to get updates. To create your company's online store, you should create your company profile. Create your Company Profile." />
);
